import * as React from "react";
import { FormDataConsumer, SelectInput } from 'react-admin';

const CAROUSEL_BG_CHOICES = [
    { id: '#AE256D', name: 'Primary (#AE256D)' },
    { id: '#0E1F58', name: 'Navy (#0E1F58)' },
];

const HomeSectionCarouselDesign = ({ isCreate = false }) => (
    <FormDataConsumer>
        {({ formData }) => {
            if (!formData?.isCarousel) return null;

            const hasBanner =
                formData.banner &&
                (formData.banner.src || formData.banner.rawFile);

            return (
                <React.Fragment>
                    <h3>Carousel Background</h3>
                    {hasBanner ? (
                        <span style={{ fontSize: 12, display: 'block', marginBottom: 12 }}>
                            Banner image is set — it will be used as the carousel background.
                        </span>
                    ) : (
                        <React.Fragment>
                            <span style={{ fontSize: 12, display: 'block', marginBottom: 8 }}>
                                No banner uploaded — pick a background color for the carousel section.
                            </span>
                            <SelectInput
                                source="carouselBgColor"
                                label="Carousel background color"
                                choices={CAROUSEL_BG_CHOICES}
                                defaultValue={isCreate ? '#AE256D' : undefined}
                                fullWidth
                            />
                        </React.Fragment>
                    )}
                </React.Fragment>
            );
        }}
    </FormDataConsumer>
);

export default HomeSectionCarouselDesign;
